// extracted by mini-css-extract-plugin
module.exports = {"link":"blogLinkStyles-module--link--1uDw-","linkText":"blogLinkStyles-module--linkText--u1BEa","image":"blogLinkStyles-module--image--7CYLe"};